<template>
  <h1 class="pageTitle">
    {{ title }}
  </h1>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.pageTitle {
  font-size: 3.6rem;
  line-height: 4.5rem;
  font-weight: 600;
  color: $cMainDark;
  text-align: left;
  margin-bottom: 3rem;

  @include rwd('tablet') {
    font-size: 3rem;
    line-height: 3.6rem;
  }
}
</style>
